import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { BedrockService } from '../services/bedrock.service'; // Update this import as per your project structure
import { AlertModalComponent } from '../alert-modal/alert-modal.component';
import { S3Service } from '../services/s3.service';

@Component({
  selector: 'app-draft-section-dialog',
  templateUrl: './draft-section-dialog.component.html',
  styleUrls: ['./draft-section-dialog.component.scss']
})
export class DraftSectionDialogComponent {
  prompt = '';
  context = '';
  filename = '';
  response = '';
  fullResponse = '';
  inProgress = false;
  draftFilename = '';
  typingIndex = 0;
  typingTimeout?: NodeJS.Timeout;
  placeholder =
    'Generate an initial draft section on ____________ for a ____________ regulatory filing submitted by __________ in the year __________';

  constructor(
    // TODO: Add Type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DraftSectionDialogComponent>,
    public dialog: MatDialog,
    private bedrockService: BedrockService,
    private s3Service: S3Service
  ) {
    this.context = data.context;
    this.filename = data.filename;
  }

  onSubmit(): void {
    this.inProgress = true;
    this.response = '';
    this.fullResponse = '';
    this.bedrockService.draftSection(this.prompt, this.context, this.filename).subscribe({
      // TODO: Add Type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      next: (response: any) => {
        this.draftFilename = response.filename;
        this.pollPromptResponse();
      },
      error: error => {
        this.openAlert('Error', 'Possible request timeout. Please check the Logs tab to see the response.');
        console.error('There was an error while drafting the section: ', error);
        this.inProgress = false;
      }
    });
  }

  pollPromptResponse() {
    const maxAttempts = 30;
    const delay = 2000;
    let attempts = 0;

    const poll = () => {
      attempts++;

      if (attempts > maxAttempts) {
        this.openAlert('Failed', 'Response timed out.');
        this.inProgress = false;
        return;
      }

      this.s3Service.pollResult(this.draftFilename).subscribe({
        // TODO: Add Type
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        next: (response: any) => {
          if (response.status === 200) {
            if (response.body.complete === 'true') {
              this.fullResponse = response.body.response;
              this.typingIndex = this.response.length;
              this.startTypingEffect();
              this.inProgress = false;
            } else {
              this.fullResponse = response.body.response;
              this.typingIndex = this.response.length;
              this.startTypingEffect();
              setTimeout(poll, delay);
            }
          } else {
            setTimeout(poll, delay);
          }
        },
        error: () => {
          this.openAlert('Failed', 'Error while polling.');
          this.inProgress = false;
        }
      });
    };

    poll();
  }

  startTypingEffect() {
    const typingSpeed = 4;

    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }

    const typeCharacter = () => {
      if (this.typingIndex < this.fullResponse.length) {
        this.response += this.fullResponse.charAt(this.typingIndex);
        this.typingIndex++;
        this.typingTimeout = setTimeout(typeCharacter, typingSpeed);
      }
    };

    typeCharacter();
  }

  copyToClipboard(): void {
    navigator.clipboard.writeText(this.response).then(
      () => {
        console.log('Copying to clipboard was successful!');
      },
      err => {
        console.error('Could not copy text: ', err);
      }
    );
  }

  openAlert(title: string, message: string): void {
    this.dialog.open(AlertModalComponent, {
      data: {
        title,
        message
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
